import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import HousingUnitList from '../housing-unit/List';

type FacilityHousingUnitsTabProps = {
  facility: Facility;
};

const FacilityHousingUnitsTab: React.FC<FacilityHousingUnitsTabProps> = ({ facility }) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <HousingUnitList facility={facility} notifyTabLoadingId="housing-units" />
      </div>
    </div>
  );
};

export default FacilityHousingUnitsTab;
